module.exports = __webpack_public_path__ + "static/zvd511lp-d2beca2d122b07663e5feaa52759db72.png";